import { Replacement } from 'roosterjs-editor-plugins';

function makeEmojiReplacement(sourceString: string, replacementHTML: string): Replacement {
    return {
        sourceString: sourceString,
        replacementHTML: replacementHTML,
        matchSourceCaseSensitive: true,
    };
}

// Used by CustomEdit, and handles autocomplete for emoji shortcuts beginning with a non-colon
// EmojiPickerPlugin handleEventExclusively when the inline emoji popup is shown
// and handles shortcut completion for all emoji which begin with a colon
const emojiReplacements: Replacement[] = [
    makeEmojiReplacement(';)', '😉'),
    makeEmojiReplacement(';-)', '😉'),
    makeEmojiReplacement(';P', '😜'),
    makeEmojiReplacement(';-P', '😜'),
    makeEmojiReplacement('<3', '❤️'),
    makeEmojiReplacement('</3', '💔'),
    makeEmojiReplacement(';*', '😘'),
    makeEmojiReplacement(';-*', '😘'),
    makeEmojiReplacement('B)', '😎'),
    makeEmojiReplacement('B-)', '😎'),
];

export default emojiReplacements;
